import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const AreYouReady = () => {

  const whatsappMessage = 'Hola, quiero comenzar con la pre-producción de la primera pieza UGC de Lácteos Barinas.';

  return (
    <Box>
      <Box
        component={Typography}
        sx={{ fontWeight: 700 }}
        variant="h4"
        gutterBottom
        align="center"
        marginBottom={2}
      >
        ¿Deseas que comencemos con la pre-producción?
      </Box>
      <Typography
        variant="h6"
        align="center"
        color="textSecondary"
        sx={{ mb: 4, maxWidth: 640, mx: 'auto' }}
      >
        Te proponemos comenzar con la primera pieza UGC de la próxima semana para Lácteos Barinas. Conecta tu marca con La Dosis Positiva y TNO Network.
      </Typography>
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={6}>
          <Box
            display="flex"
            flexDirection={{ xs: 'column', sm: 'row' }}
            justifyContent="center"
            gap={2}
          >
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={() => {
                const url = `https://wa.me/584123964576?text=${encodeURIComponent(whatsappMessage)}`;
                window.open(url, '_blank');
              }}
            >
              Sí, comenzar pre-producción
            </Button>
            <Button
              href="https://www.tnonetwork.com"
              variant="outlined"
              color="primary"
              size="large"
              target="_blank"
              rel="noopener noreferrer"
            >
              Conocer TNO Network
            </Button>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box display="flex" justifyContent="center" alignItems="center">
            <Box
              component="img"
              src="/images/yanirabellatno.jpeg"
              alt="La Dosis Positiva - TNO Network"
              sx={{
                width: '100%',
                maxWidth: 400,
                borderRadius: 2,
                boxShadow: 3,
                objectFit: 'cover',
              }}
            />
          </Box>
        </Grid>
      </Grid>
      <Box marginTop={4} textAlign="center">
        <Typography variant="body2" color="textSecondary">
          © TNO Network 2026 | Lácteos Barinas & La Dosis Positiva.
        </Typography>
      </Box>
    </Box>
  );
};

export default AreYouReady;
